<template>
  <div>
    <v-card class="rounded-lg" color="#41916b" elevation="0">
      <v-tabs v-model="tab" fixed-tabs background-color="#41916b" dark>
        <v-tabs-slider color="#b1e3cc"></v-tabs-slider>
        <v-tab
          >{{ $t('titles.glasgow_scale') }} -
          {{
            this.donorForm.name === "Paciente não identificado"
              ? "Nº DO PRONTUÁRIO " + this.donorForm.medical_records
              : this.donorForm.name
          }}
        </v-tab>

        <v-tab-item>
          <v-form
            @submit.prevent="activeSearchForm"
            ref="form"
            :disabled="disableScaleForm"
          >
            <v-container>
              <p v-if="!resource.death_data" style="font-weight: bold">
                {{ $t('descriptions.scale_and_description') }}
              </p>
              <v-row dense v-if="!resource.death_data">
                <v-col class="d-flex" cols="12" sm="2">
                  <v-select
                  data-cy="select-escala"
                    :items="glasgowItems"
                    :rules="formRules"
                    color="#086318"
                    v-model="glasgowScale.description"
                    class="rounded-lg"
                    item-value="value"
                    item-text="description"
                    dense
                    outlined
                  >
                    <template v-slot:label>
                      {{ $t('inputs.glasgow_scale.description') }} <span style="color: red">*</span>
                    </template>
                  </v-select>
                </v-col>
                <v-col class="d-flex" cols="12" sm="8">
                  <v-select
                  data-cy="select-condicao"
                    color="#256936"
                    class="rounded-lg"
                    :rules="formRules"
                    :items="conditions"
                    item-value="id"
                    item-text="description"
                    outlined
                    v-model="glasgowScale.condition_id"
                    dense
                  >
                    <template v-slot:label>
                      {{ $t('inputs.glasgow_scale.condition_id') }} <span style="color: red">*</span>
                    </template>
                  </v-select>
                </v-col>
                <v-col
                  class="d-flex"
                  cols="12"
                  sm="1"
                  v-if="!resource.death_data"
                >
                  <v-tooltip
                    top
                    color="#236947"
                    v-if="enableEditButton == false"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn
                        data-cy="btn-adicionar-escala"
                        class="mx-1"
                        small
                        fab
                        dark
                        color="#236947"
                        v-bind="attrs"
                        v-on="on"
                        :disabled="disableScaleForm"
                        @click="addGlasgowScale()"
                      >
                        <v-icon dark>mdi-plus</v-icon>
                      </v-btn>
                    </template>
                    <span style="color: white">Inserir escala</span>
                  </v-tooltip>
                  <v-tooltip top color="#236947">
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn
                        class="mx-1"
                        small
                        fab
                        dark
                        color="#236947"
                        v-bind="attrs"
                        v-on="on"
                        :disabled="disableScaleForm"
                        @click="clearFields()"
                      >
                        <v-icon dark>mdi-broom</v-icon>
                      </v-btn>
                    </template>
                    <span style="color: white">{{$t('buttons.clean_up')}}</span>
                  </v-tooltip>
                  <v-tooltip
                    top
                    color="#236947"
                    v-if="enableEditButton == true"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn
                        class="mx-1"
                        small
                        fab
                        dark
                        color="#21bf68"
                        v-bind="attrs"
                        v-on="on"
                        :disabled="disableScaleForm"
                        @click="editScale()"
                      >
                        <v-icon dark>mdi-check</v-icon>
                      </v-btn>
                    </template>
                    <span style="color: white">{{$t('buttons.save')}}</span>
                  </v-tooltip>
                </v-col>
              </v-row>
              <v-row dense v-if="glasgowScale.condition_id == 5">
                <v-col class="d-flex" cols="12">
                  <v-textarea
                    class="rounded-lg"
                    color="#086318"
                    row-height="10"
                    rows="2"
                    :rules="formRules"
                    :placeholder="$t('inputs.glasgow_scale.condition_other_placeholder')"
                    outlined
                    dense
                    v-model="glasgowScale.condition_other"
                  >
                    <template v-slot:label>
                      {{ $t('inputs.glasgow_scale.condition_other') }} <span style="color: red">*</span>
                    </template>
                  </v-textarea>
                </v-col>
              </v-row>
              <br />
              <template>
                <v-data-table
                  :headers="headers"
                  :items="glasgow"
                  :items-per-page="10"
                  class="elevation-1"
                  :footer-props="{
                    'items-per-page-text': 'Escalas por página',
                  }"
                >
                  <template #no-data>
                    <div class="text-center py-4">Nenhuma evolução ainda</div>
                  </template>
                  <template v-slot:item.actions="{ item }" :resource="item">
                    <v-tooltip bottom color="#50c78f">
                      <template v-slot:activator="{ on, attrs }">
                        <v-icon
                          size="20"
                          class="icon"
                          color="#50c78f"
                          v-on="on"
                          v-bind="attrs"
                          align-item="center"
                          :disabled="resource.death_data"
                          @click="editGlasgowScale(item)"
                        >
                          mdi-pen
                        </v-icon>
                      </template>
                      <span style="color: white">{{$t('buttons.edit')}}</span>
                    </v-tooltip>
                    <v-tooltip bottom color="#50c78f" v-if="item.description == 3">
                      <template v-slot:activator="{ on, attrs }">
                        <v-icon
                          size="20"
                          class="icon"
                          color="#50c78f"
                          v-on="on"
                          v-bind="attrs"
                          align-item="center"
                          :disabled="resource.death_data"
                          @click="viewItem(item)"
                        >
                          mdi-eye
                        </v-icon>
                      </template>
                      <span style="color: white">Visualizar</span>
                    </v-tooltip>
                  </template>
                </v-data-table>
              </template>

              <p class="space-personalized"></p>

              <v-row class="action-buttons">
                <v-btn
                 data-cy="btn-start-pme"
                  class="rounded-lg action-btn"
                  elevation="0"
                  :loading="loadingPMEButton"
                  color="#db4d4f"
                  v-if="openPMEButton"
                  @click="handleStartPME"
                >
                  <span class="textBtn text-white">
                    Iniciar Protocolo de Morte Encefálica
                  </span>
                </v-btn>

                <v-btn
                  class="rounded-lg action-btn"
                  elevation="0"
                  color="#41916b"
                  @click="getPdf()"
                  v-if="pdfButton"
                >
                  <span class="textBtn text-white">
                    <v-icon class="btn-icon">mdi-file-pdf-box</v-icon>
                    Gerar PDF
                  </span>
                </v-btn>

                <v-btn
                  class="rounded-lg action-btn"
                  text
                  outlined
                  color="#41916b"
                  @click="$router.push('/pacientes')"
                >
                  <v-icon>mdi-arrow-left-bold</v-icon>
                </v-btn>
              </v-row>
            </v-container>
          </v-form>
        </v-tab-item>
      </v-tabs>
    </v-card>

    <v-dialog v-model="dialog" width="600px" persistent>
      <ModalBuscaAtivaComp
        :donorId="donorId ? donorId : donorForm.id"
        :glasgowId="glasgowId"
        :avNeurologica="avNeurologica"
        :glasgowDescription="glasgowScale.description"
        @fechar="(dialog = false), indoGlasgowTable()"
        @openIdentifiedCard="notIdentified = $event"
      />
    </v-dialog>

    <v-dialog v-model="notIdentified" width="400" persistent>
      <v-card class="mx-auto" max-width="400" elevation="12" rounded>
        <v-card-title class="headline d-flex align-center" style="color: #444">
          <v-icon left color="red darken-3" size="32"
            >mdi-alert-circle-outline</v-icon
          >
          Paciente não identificado
        </v-card-title>

        <v-card-text class="text-body-1" style="color: #444">
          {{ $t('messages.cant_advance') }}
          <br />
          {{ $t('messages.patient_identified') }}
        </v-card-text>

        <v-card-actions class="justify-end">
          <v-btn color="red darken-3" dark rounded @click="redirect()">
            <v-icon left>mdi-refresh</v-icon> {{$t('buttons.to_update')}}
          </v-btn>
          <v-btn text color="grey" rounded @click="notIdentified = false">
            {{$t('buttons.close')}}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="dialogPMEDate" width="450px" persistent>
      <StartingPME
        :loading="loadingPMEButton"
        @submit="submitPMEStart"
        @cancel="dialogPMEDate = false"
      />
    </v-dialog>

    <v-overlay :value="loadingPDF">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>
  </div>
</template>
<script>
import axios from "@/axios";
import { mapGetters, mapActions } from "vuex";
import ModalBuscaAtivaComp from "@/components/modals/ModalBuscaAtiva-comp.vue";
import StartingPME from "@/components/pacientes/provavel-doador/escalaGlasgow/StartingPME.vue";
import Formatters from "@/utils/Formatters";
import currentUser from "@/utils/currentUser";
export default {
  name: "EscalaGlasgow-comp",
  data: () => ({
     displayError: {
      message: "",
      display: false,
    },

    startPMEAfteridentify: false,
    glasgowScale: {},
    enableEditButton: false,
    glasgowItems: Array.from({ length: 13 }, (v, i) => ({
      description: `Escala ${i + 3}`,
      value: i + 3,
    })),
    pmeButton: false,
    headers: [
      {
        text: "Escala de Glasgow",
        value: "description",
        align: "center",
      },  
      {
        text: "Condição",
        value: "condition.description",
        align: "center",
      },
      {
        text: "Data",
        value: "created_at",
        align: "center",
      },
      {
        text: "Ações",
        value: "actions",
        align: "center",
      },
    ],
    formRules: [(value) => !!value || "Campo obrigatório."],
    disableScaleForm: false,
    disableButton: false,
    tab: 0,
    glasgow: [],
    glasgowId: "",
    donorForm: {},
    dialog: false,
    conditions: [],
    notIdentified: false,
    dialogPMEDate: false,
    pme_start_datetime: '',
    loadingPMEButton: false,
    avNeurologica: {},
    loadingPDF: false,
    pdfButton: false,
  }),

  components: {
    ModalBuscaAtivaComp,
    StartingPME,
  },

  computed: {
    ...mapGetters({
      resource: "getPatientData",
      donorId: "getDonorId",
    }),

    currentUser(){
      return currentUser.getUserData()
    },

    user_id(){
      return this.currentUser.id
    },

    openPMEButton() {
      return this.glasgow.some(item => {
        if(item.description != 3) return false;

        const prerequisit = item.pme_prerequisites;

        if(!prerequisit || !prerequisit.length) return false;

        return prerequisit[0].flg_fund == true;
      });
    }
  },

  mounted() {
    this.donorForm = this.resource;
    this.indoGlasgowTable();
    this.getConditions();
  },

  methods: {
    ...mapActions([
      "changeSnackBarData",
      "changePatientData",
      "changeDonorId", 
    ]),

    handleStartPME() {
      if(!this.resource.cpf) {
        this.startPMEAfterIdentify = true;
        this.notIdentified = true;
        return;
      }
      this.dialogPMEDate = true;
    },

    submitPMEStart(pme_start_datetime) {
      this.pme_start_datetime = pme_start_datetime;
      this.dialogPMEDate = false;
      this.updateDonorStatus();
    },


    addGlasgowScale() {
      if (this.$refs.form.validate()) {
        this.glasgowScale.donor_id = this.resource.id
          ? this.resource.id
          : this.donorId;
        this.glasgowScale.user_id = this.user_id;

        const glasgowScale = this.glasgowScale;
      
        axios
          .post(`/glasgow_scale`, glasgowScale)
          .then((response) => { 
            this.successActions(response.data); 
          }).catch((err) => {
            err;
            var error = "";
            Object.values(this.$store.state.errorMessage).map((value) => {
              error = value;
            });
            this.message = error;
            this.snackbar = true;
            this.displayError.message = error.toString();
            this.displayError.display = true;
            setTimeout(() => {
              this.displayError.display = false;
            }, 3000);
          });
      }
    },

    successActions(data) { 
      this.avNeurologica = {};

      this.glasgowId = data.id.id;
      this.message = data.message;
      this.snackbar = true;
 
      if(this.glasgowScale.description == 3) {
        this.dialog = true;
      }else{
        this.indoGlasgowTable();
      }

      this.resetForm();
    },

    resetForm() {
      this.glasgowScale.condition_id = "";
      this.glasgowScale.description = "";
      this.glasgowScale.condition_other = "";

      this.activateButtons = true;
      this.disableButtonScaleForm = false;

      this.$refs.form.resetValidation();
    },

    indoGlasgowTable() {
      let id = this.resource.id ? this.resource.id : this.donorId;
      axios.get(`/glasgow_scale/donor/${id}`).then((response) => {
        this.glasgow = response.data;

        if (this.glasgow.length >= 1) {
          this.pdfButton = true;
          const hasDescription3 = this.glasgow.some(
            (item) => item.description == 3
          );

          if (hasDescription3) {
            this.pmeButton = true;
          }
        }
      });
    },

    getConditions() {
      axios.get(`/conditions`).then((response) => {
        this.conditions = response.data ? response.data : response.data.data;
      });
    },

    editGlasgowScale(item) {
      this.glasgowScale = {
        id: item.id,
        description: Number(item.description),
        condition_id: parseInt(item.condition_id),
        condition_other: item.condition_other || null,
      };
      this.enableEditButton = true;
      this.itemScaleID = item.id;
 
      this.$nextTick(() => {
        if (this.$refs.form) {
          this.$refs.form.resetValidation();
        }
      });
    },

    editScale() {
      this.glasgowScale.donor_id = this.resource.id
        ? this.resource.id
        : this.donorId;
      this.glasgowScale.user_id = this.user_id;
      axios
        .put(`/glasgow_scale/${this.glasgowScale.id}`, this.glasgowScale)
        .then((response) => {
          this.enableEditButton = false;
          this.clearFields(),
            this.changeSnackBarData({
              status: true,
              type: "success",
              titleMessage: response.data.message,
              bodyMessage: "",
              cardColor: "#41916b",
              titleIcon: "mdi-checkbox-marked-circle",
            });

          setTimeout(() => {
            this.indoGlasgowTable(this.glasgowScale.donor_id);
            this.closeSnackBar();
          }, 3000);
        })
        .catch((err) => {
          this.changeSnackBarData({
            status: true,
            type: "erro",
            titleMessage: "Algo deu errado!",
            bodyMessage: err.erro,
            cardColor: "red",
            titleIcon: "mdi-close-circle",
          });

          setTimeout(() => {
            this.closeSnackBar();
            this.cam;
          }, 3000);
        });
    },

    closeSnackBar() {
      this.changeSnackBarData({
        status: false,
        type: "",
        titleMessage: "",
        bodyMessage: "",
        cardColor: "",
        titleIcon: "",
      });
    },
 
    updateDonorStatus() {
      this.loadingPMEButton = true;
      const donor_id = this.resource.id ? this.resource.id : this.donorId;
      const data = {
        user_id: this.user_id,
        donor_id: donor_id,
        date_and_time_of_the_first_exam: Formatters.removeNonNumeric(this.pme_start_datetime),
        date_and_time_of_the_last_exam: null 
      }

      axios.post(`/brain_death_protocols`, data).then(() => {
        setTimeout(() => {
          this.loadingPMEButton = false;
          this.changeDonorId(donor_id);
          this.changePatientData({
            ...this.resource,
            donor_status: {
              slug: 'aguard-aval-med'
            }
          })
          this.$router.push("/informes-clinicos");
        }, 3000);
      }).catch((err) => { 
        this.changeSnackBarData({
          status: true,
          type: "erro",
          titleMessage: "Algo deu errado!",
          bodyMessage: err.details,
          cardColor: "red",
          titleIcon: "mdi-close-circle",
        });

        setTimeout(() => {
          this.loadingPMEButton = false;
          this.closeSnackBar();
        }, 5000);
      })
    },

    viewItem(item) {
      this.avNeurologica = item;
      this.glasgowId = item.id;
      this.dialog = true;
    },

    clearFields() {
      this.$refs.form.resetValidation();
      this.glasgowScale = {
        description: "",
        condition_id: "",
        condition_other: "",
      };
      this.enableEditButton = false;
    },

    redirect() {
      this.resource.id = this.resource.id ? this.resource.id : this.donorId;
      this.resource.action = "redirect";
      this.changePatientData(this.resource);
      this.$router.push({ path: "/cadastrar-paciente" });
    },

    getPdf() {
      this.loadingPDF = true;
      const id = this.resource.id ? this.resource.id : this.donorId;

      axios
        .get(`/donor/pdf/${id}`, {
          responseType: "blob",
        })
        .then((response) => {
          this.loadingPDF = false;
          let url = window.URL.createObjectURL(new Blob([response.data]));
          let link = document.createElement("a");
          link.href = url;
          let nome = (this.resource.name || "paciente")
            .trim()
            .replace(/\s+/g, "_");
          link.setAttribute("download", `glasgow${nome}.pdf`);

          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
          window.URL.revokeObjectURL(url);
        })
        .catch((error) => {
          this.loadingPDF = false;
          this.changeSnackBarData({
            status: true,
            type: "erro",
            titleMessage: "Algo deu errado!",
            bodyMessage: error.details,
            cardColor: "red",
            titleIcon: "mdi-close-circle",
          });

          setTimeout(() => {
            this.closeSnackBar();
          }, 5000);
        });
    },
  },
};
</script>
<style scoped>
.action-buttons {
  margin: 8px 8px 8px 0;
  display: flex;
  justify-content: flex-end;
}

.action-btn {
  margin-right: 4px;
}

.action-btn:last-child {
  margin-right: 0;
}

.text-white {
  color: #fff;
}

.btn-icon {
  margin-right: 4px;
}

@media (max-width: 768px) {
  .action-buttons {
    flex-direction: column;
  }

  .action-btn {
    width: 100%;
    margin-right: 0;
    margin-bottom: 8px;
  }

  .action-btn:last-child {
    margin-bottom: 0;
  }
}
</style>
